export default __webpack_public_path__ + "1a0bd37.png";